<template>
<div class="card card3 col">
  <div class="card_link" @click="open_allow('open_3')">
    <div class="card_nr"><h2 class="nr">3</h2></div>
  </div>
</div>
<!-- TAG 3 -->
<div class="trailer_03">
  <div class="trailer_box">
      <div class="video_box">
        <div class="lds-dual-ring" v-if="loading"></div>
        <video loop autoplay class="video_03" v-if="video_view">
          <source v-bind:src="require('./../assets/videos/' + video_name_webm_3)" type="video/webm" />
          <source v-bind:src="require('./../assets/videos/' + video_name_mp4_3)" type="video/mp4" />
        </video>
      </div>
      <div class="text_box">
        <p>{{text_3_1}}</p>
        <p>{{text_3_2}}<br />{{text_3_3}}<br /><a href="https://www.vhs-mittelsachsen.de/programm/kunst-und-kultur.html?params=%7B%22filter%22%3Atrue%2C%22noHeadline%22%3Atrue%2C%22noHeaders%22%3Atrue%7D&socketsId=17&filters%5BignoreGlobalFilters%5D=&filters%5Bparams%5D=%7B%22tophighlights%22%3Anull%2C%22extraFields%22%3A%5B%22tags%22%2C%22dateCount%22%2C%22customVenueText%22%2C%22courseNumber%22%2C%22maxAttend%22%2C%22title%22%2C%22startDate%22%2C%22venues.city%22%2C%22additionalInfoIcon%22%2C%22customDatesText%22%2C%22tags%22%5D%2C%22hideEmptyCategories%22%3Afalse%2C%22catId%22%3A%22590-CAT-KAT978%22%2C%22ignoreGlobalFilters%22%3A%22%22%2C%22searchString%22%3A%22Amelie+Mahlstedt%22%2C%22returnType%22%3A%22default%22%7D&course_url=%252F%252Fwww.vhs-mittelsachsen.de%252Fprogramm%252Fkunst-und-kultur.html%253Faction%25255B17%25255D%253Dcourse&plugin_url=%2F%2Fwww.vhs-mittelsachsen.de%2Fprogramm%2Fkunst-und-kultur.html&sockets_ID=17&filters%5BsearchString%5D=Amelie+Mahlstedt&filters%5BweekdayExclude%5D%5B1%5D=on&filters%5BweekdayExclude%5D%5B2%5D=on&filters%5BweekdayExclude%5D%5B3%5D=on&filters%5BweekdayExclude%5D%5B4%5D=on&filters%5BweekdayExclude%5D%5B5%5D=on&filters%5BweekdayExclude%5D%5B6%5D=on&filters%5BweekdayExclude%5D%5B7%5D=on&filters%5BsearchString%5D=Amelie+Mahlstedt" target="_blank">{{text_3_4}}</a>
        </p>
        <p>
          <picture>
                <source v-bind:srcset="require('./../assets/images/' + img_logo_musikschule_webp)" type="image/webp">
                <source v-bind:srcset="require('./../assets/images/' + img_logo_musikschule_png)">
                <img v-bind:srcset="require('./../assets/images/' + img_logo_musikschule_png)" alt="{{img_logo_musikschule_alt}}">
          </picture>
        </p>
      </div>
      <picture>
                <source v-bind:srcset="require('./../assets/images/' + img_close_webp)" type="image/webp">
                <source v-bind:srcset="require('./../assets/images/' + img_close_png)">
                <img class="close" v-bind:srcset="require('./../assets/images/' + img_close_png)" @click="close_3" alt="{{img_close_alt}}">
      </picture>
  </div>
</div>
<!-- TAG GESCHLOSSEN --> 
<div class="trailer_27">
  <div class="trailer_box">
      <div class="text_box text_box_27">
        <p>{{text_27_1}}</p>
        <p>{{text_27_2}}<br />{{text_27_3}}</p>
        <p>
          <picture>
                <source v-bind:src="require('./../assets/images/' + img_logo_musikschule_webp)" type="image/webp">
                <source v-bind:src="require('./../assets/images/' + img_logo_musikschule_png)">
                <img v-bind:src="require('./../assets/images/' + img_logo_musikschule_png)" alt="{{img_logo_musikschule_alt}}">
          </picture>
        </p>
      </div>
      <picture>
                <source v-bind:src="require('./../assets/images/' + img_close_webp)" type="image/webp">
                <source v-bind:src="require('./../assets/images/' + img_close_png)">
                <img class="close_schwarz" v-bind:src="require('./../assets/images/' + img_close_png)" @click="close_27" alt="{{img_close_alt}}">
      </picture>
  </div>
</div>
</template>
<script>
import Moment from 'moment';
export default {
  name: 'KalenderCard3',
  data: function() {
    return {
      /* BILDER */
      img_logo_musikschule_webp: "logo-volkshochschule-mittelsachsen.webp",
      img_logo_musikschule_png: "logo-volkshochschule-mittelsachsen.png",
      img_logo_musikschule_alt: "Volkshochschule Mittelsachsen",
      img_close_webp: "close.webp",
      img_close_png: "close.png",
      img_close_alt: "Schließen",
      /* TAG 3 */
      tag: "3",
      datum: "03.12.2024",
      text_3_1: "Meditatives Schreiben in der Adventszeit",
      text_3_2: "Interpretin: Amelie Mahlstedt",
      text_3_3: "Beitrag von der Volkshochschule Freiberg",
      text_3_4: "vhs-Kurse mit Amelie Mahlstedt",
      video_name_webm_3: "03.webm",
      video_name_mp4_3: "03.mp4",


      /* TAG 27 */
      text_27_1: "Neugierig?",
      text_27_2: "Das Türchen darf noch nicht geöffnet werden.",
      text_27_3: "Sei noch etwas geduldig und warte bis zu diesem Tag :)",

      video_view: false,
      loading: false,
      response_webm: '',
      response_mp4: '',
      controller: '',
    }
  },
  methods: {
    trailer() {return true;},
    open_allow(nummer) {
      if(this.isAllowedToView) { // Tag offen
        var open_nr = nummer;
        this[open_nr]();
        this.loadTrailer();
      } 
      else { // Tag gesperrt ... open_27()
        this.open_27();
      }
    },
    async loadTrailer() {
      this.video_view = true;
      this.loading = true;
      this.$http;
      let video_03 = document.querySelector('.video_03');
      let url_webm = '/media/' + this.video_name_webm_3;
      let url_mp4 = '/media/' + this.video_name_mp4_3;
      this.controller = new AbortController();
      const signal = this.controller.signal
      try {
        this.response_webm = await this.axios.get(url_webm, {signal});
        this.response_mp4 = await this.axios.get(url_mp4, {signal});
        //console.log('get webm: ' + this.response_webm.statusText); 
        //console.log('get mp4: ' + this.response_mp4.statusText);
        video_03.currentTime = 0;this.silencePromise(video_03.play());
      } catch(err) {
        //console.log(err.message);
      }
      this.loading = false;
    },
    isPromise(value) {
      return value !== undefined && value !== null && typeof value.then === 'function';
    },
    silencePromise(value) {
      if (this.isPromise(value)) {
        value.then(null, (e) => {console.log(e);});
      }
    },
    stopVideo() {
      let video_03 = document.querySelector('.video_03');
      video_03.load();
      video_03.currentTime = 0;
      this.controller.abort();
      //console.log('abbruch webm: ' + this.response_webm.statusText); 
      //console.log('abbruch mp4: ' + this.response_mp4.statusText); 
      var videos = document.querySelectorAll('video');
      Array.prototype.forEach.call(videos, function (video) {
        if (video.tagName.toLowerCase() === 'video') {
          video.pause();
        } else {
          var src = video.src;
          video.src = src;
        }
      });
    },
    open_3() { var trailer_03 = document.querySelector('.trailer_03');window.scrollTo(0, 0);trailer_03.classList.toggle('active');},
    close_3() {var trailer_03 = document.querySelector('.trailer_03');trailer_03.classList.toggle('active');this.stopVideo();},
    open_27() { var trailer_27 = document.querySelector('.trailer_27');window.scrollTo(0, 0);trailer_27.classList.toggle('active');},
    close_27() {var trailer_27 = document.querySelector('.trailer_27');trailer_27.classList.toggle('active');},
  },
  computed: {
     datumCard: function () {
      return new Moment(this.datum, 'DD.MM.YYYY')
    },
    heute: function () {
      return new Moment()
    },
    isAllowedToView: function () {
      return this.datumCard <= this.heute
    },
  },
}
</script>
<style scoped lang="scss">
@import './../scss/variablen.scss';
@import './../scss/mixins.scss';
@import './../scss/style.scss';
@import './../scss/KalenderCard.scss';
@import './../scss/KalenderCardOpen.scss';
</style>